import { useFocusedMeetingAPI } from "../../../../hooks/meeting";
import { useExpertContext } from "../context";
import "./group.css";
import { ExpertsToRemotesContainer } from "../../../../components/player/container/ExpertsToRemotesContainer";
import { PedagogyInterventionTopBar, ReactIcons } from "@kalyzee/escaet-ui";
import styles from "./withPedagogy.module.css";

export const MeetingExpertsWithPedagogyPage = () => {
  const meetingContainerAPI = useFocusedMeetingAPI();
  const expertCtx = useExpertContext();

  const currentView = expertCtx?.currentView;

  if (currentView?.type !== "activity_pedagogy") {
    return null; // impossible
  }

  return (
    <div style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column" }}>
      <PedagogyInterventionTopBar
        title={
          <div className={styles.expertTopBarContent}>
            <ReactIcons.HeadphonePresence color={"#FFFFFF88"} width={24} height={24} style={{ marginRight: 10 }} />
            échanger avec la pédagogie
          </div>
        }
        forceOpen
        style={{ height: 60 }}
      />
      <div style={{
        flex: 1,
        width: "100%",
        padding: "2em",
        minHeight: 0,
      }}>
      <ExpertsToRemotesContainer
        meetingContainerAPI={meetingContainerAPI}
        context={expertCtx}
        remoteSessions={currentView.experts.map(s => s.session)}
        showSelf="new_source"
      />
      </div>
    </div>
  );
}
